export const ProductStepEnums = Object.freeze({
    CATEGORIES: 'categories',
    GENDERS: 'genders',
});

export const AllProductStepEnums = Object.freeze([
    ProductStepEnums.CATEGORIES,
    ProductStepEnums.GENDERS
])
